import React, { useState, useEffect } from 'react';
import Style from './../../Css/About.module.scss';
import Terminal from "./Terminal";
import { Box } from "@mui/material";
import api from "./../../Service/GlobalApi";
import { info } from '../../info/Info';

export default function About()
{
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() =>
    {
        const fetchData = async () =>
        {
            try
            {
                const aboutData = await api.fetchDataFromServer("About");
                const skillsData = await api.fetchDataFromServer("Skills");
                const hobbiesData = await api.fetchDataFromServer("Hobbies");
                const educationData = await api.fetchDataFromServer("Education");
                const voluntarilyData = await api.fetchDataFromServer("Voluntarily");
                const workData = await api.fetchDataFromServer("WorkExperience");
                const recommendationData = await api.fetchDataFromServer("Recommendation");

                const transformedData = {
                    firstName: aboutData[0].firstName,
                    lastName: aboutData[0].lastName,
                    position: aboutData[0].position,
                    selfPortrait: aboutData[0].selfPortrait,
                    bio: aboutData[0].bio,
                    skills: skillsData,
                    hobbies: hobbiesData,
                    education: educationData,
                    voluntarily: voluntarilyData,
                    work: workData,
                    recommendation: recommendationData
                };

                setData(transformedData);
            } catch (error)
            {
                console.error("Error fetching data:", error);
                console.error("Error details:", error.response || error.message || error);
            } finally
            {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading || !data)
    {
        return (
            <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                height={'100vh'}
                fontSize={'2rem'}
            >
                <div className={Style.loadingAnimation}>
                    <span role="img" aria-label="loading">
                        ⌛️
                    </span>
                    Loading...
                </div>
            </Box>
        );
    }
    const firstName = data.firstName

    function aboutMeText()
    {
        return <>
            <p><span style={{ color: info.baseColor }}>{firstName} {data.lastName.toLowerCase()} $</span> cat
                about {firstName} </p>
            <p><span style={{ color: info.baseColor }}>about {firstName} <span
                className={Style.green}>(main)</span> $ </span>
                {data.bio}
            </p>
        </>;
    }

    function educationText()
    {
        return (
            <>
                <p>
                    <span style={{ color: info.baseColor }}>
                        {firstName} {data.lastName.toLowerCase()} $
                    </span>{' '}
                    cat education
                </p>
                <div>
                    <p>
                        <span style={{ color: info.baseColor }}>
                            education{' '}
                            <span className={Style.green}>(main)</span> $
                        </span>{' '}
                    </p>
                    <ul>
                        {data.education.map((item, index) => (
                            <li key={index}>
                                <Box component={'span'} mr={'1rem'}>
                                    <Box component={'span'} fontWeight={'bold'} style={{ fontSize: '1.5rem' }}>
                                        {item.educationTitle}&nbsp;
                                        {item.educationStartDate} -{' '}
                                        {item.educationEndDate}
                                    </Box>
                                    <br />
                                    <Box component={'span'} className={Style.textStyle}> {item.educationSubTitle}</Box>
                                    <br />
                                    <br />
                                    <Box component={'span'} className={Style.textStyle}>
                                        {item.educationDetail.split('\n').map((detail, index) => (
                                            <React.Fragment key={index}>
                                                {detail}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                    <br />
                                </Box>
                                <hr />
                            </li>
                        ))}
                    </ul>
                </div>
            </>
        );
    }

    function worksText()
    {
        return (
            <>
                <p>
                    <span style={{ color: info.baseColor }}>
                        {firstName} {data.lastName.toLowerCase()} $
                    </span>{' '}
                    cat work
                </p>
                <div>
                    <p>
                        <span style={{ color: info.baseColor }}>
                            work{' '}
                            <span className={Style.green}>(main)</span> $
                        </span>{' '}
                    </p>
                    <ul>
                        {data.work.map((item, index) => (
                            <li key={index}>
                                <Box component={'span'} mr={'1rem'}>
                                    <Box component={'span'} fontWeight={'bold'} style={{ fontSize: '1.5rem' }}>
                                        {item.workTitle}&nbsp;
                                        {item.workStartDate} -{' '}
                                        {item.workEndDate}
                                    </Box>
                                    <br />
                                    <Box component={'span'} className={Style.textStyle}> {item.workSubTitle}</Box>
                                    <br />
                                    <br />

                                    <Box component={'span'} className={Style.textStyle}>
                                        {item.workDetail.split('\n').map((detail, index) => (
                                            <React.Fragment key={index}>
                                                {detail}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                    <br />
                                </Box>
                                <hr />
                            </li>
                        ))}
                    </ul>
                </div>
            </>
        );
    }

    function recommendationText()
    {
        return (
            <>
                <p>
                    <span style={{ color: info.baseColor }}>
                        {firstName} {data.lastName.toLowerCase()} $
                    </span>{' '}
                    cat recommendation
                </p>
                <div>
                    <p>
                        <span style={{ color: info.baseColor }}>
                            recommendation{' '}
                            <span className={Style.green}>(main)</span> $
                        </span>{' '}
                    </p>
                    <ul>
                        {data.recommendation.map((item, index) => (
                            <li key={index}>
                                <Box component={'span'} mr={'1rem'}>
                                    <Box component={'span'} fontWeight={'bold'} style={{ fontSize: '1.5rem' }}>
                                        <a href={item.website} target="_blank" rel="noopener noreferrer">{item.personNameSurname}</a>&nbsp;
                                        {item.personTitle}
                                    </Box>
                                    <br />
                                    <Box component={'span'} className={Style.textStyle}> {item.connection}</Box>
                                    <br />
                                    <br />

                                    <Box component={'span'} className={Style.textStyle}>{item.recommendationDetail}  </Box>
                                    <br />
                                </Box>
                                <hr />
                            </li>
                        ))}
                    </ul>
                </div>
            </>
        );
    }

    function skillsText()
    {
        return <>
            <p><span style={{ color: info.baseColor }}>{firstName}{data.lastName.toLowerCase()} $</span> cd skills/tools
            </p>
            <p><span style={{ color: info.baseColor }}>skills/tools <span
                className={Style.green}>(main)</span> $</span> ls</p>
            <p style={{ color: info.baseColor }}> Proficient With</p>
            <ul className={Style.skills}>
                {data.skills.map((skill, index) => <li key={index}>{skill.name}</li>)}
            </ul>
        </>;
    }

    function voluntarilyText()
    {
        return (
            <>
                <p>
                    <span style={{ color: info.baseColor }}>
                        {firstName} {data.lastName.toLowerCase()} $
                    </span>{' '}
                    cat voluntarily
                </p>
                <div>
                    <p>
                        <span style={{ color: info.baseColor }}>
                            voluntarily{' '}
                            <span className={Style.green}>(main)</span> $
                        </span>{' '}
                    </p>
                    <ul>
                        {data.voluntarily.map((item, index) => (
                            <li key={index}>
                                <Box component={'span'} mr={'1rem'}>
                                    <Box component={'span'} fontWeight={'bold'} style={{ fontSize: '1.5rem' }}>
                                        {item.voluntarilyTitle}&nbsp;
                                        {item.voluntarilyStartDate} -{' '}
                                        {item.voluntarilyEndDate}
                                    </Box>
                                    <br />
                                    <Box component={'span'} className={Style.textStyle}> {item.voluntarilySubTitle}</Box>
                                    <br />
                                    <br />

                                    <Box component={'span'} className={Style.textStyle}>
                                        {item.voluntarilyDetail.split('\n').map((detail, index) => (
                                            <React.Fragment key={index}>
                                                {detail}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                    <br />
                                </Box>
                                <hr />
                            </li>
                        ))}
                    </ul>
                </div>
            </>
        );
    }

    function hobbiesText()
    {
        return <>
            <p><span style={{ color: info.baseColor }}>{firstName}{data.lastName.toLowerCase()} $</span> cd
                hobbies/interests</p>
            <p><span style={{ color: info.baseColor }}>hobbies/interests <span
                className={Style.green}>(main)</span> $</span> ls</p>
            <ul>
                {data.hobbies.map((item, index) => (
                    <li key={index}>
                        <Box component={'span'} mr={'1rem'}>
                            <Box component={'span'} fontWeight={'bold'} style={{ fontSize: '1.5rem' }}>
                                {item.emoji}&nbsp;
                                {item.label}
                            </Box>
                            <br />
                            <br />
                            <Box component={'span'} className={Style.textStyle}>
                                {item.explanation.split('\n').map((explanation, index) => (
                                    <React.Fragment key={index}>
                                        {explanation}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </Box>
                            <br />
                        </Box>
                        <hr />
                    </li>
                ))}
            </ul>
        </>;
    }

    return (
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'} width={'100%'}>
            <Terminal text={aboutMeText()} />
            <Terminal text={educationText()} />
            <Terminal text={worksText()} />
            <Terminal text={recommendationText()} />
            <Terminal text={skillsText()} />
            <Terminal text={voluntarilyText()} />
            <Terminal text={hobbiesText()} />
        </Box>
    );

}
